/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 Violin.glb --transform 
Files: Violin.glb [45.85KB] > C:\Users\alexr\Documents\Development\Lofi site\public\Instruments\Violin-transformed.glb [7.12KB] (84%)
*/

import React, { useRef, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { Sparkles } from "@react-three/drei";

export function Violin(props) {
  const { nodes, materials } = useGLTF("/Instruments/Violin-transformed.glb");
  const [sound, setSound] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const clickHandler = () => {
    console.log("clicked violin");
    if (isPlaying == false) {
      const sound = new Howl({
        src: "/sounds/violin.mp3",
        autoplay: false,
        volume: 0.3,
        onplay: () => {
          setIsPlaying(true);
          //requestAnimationFrame(step);
          // console.log(isPlaying);
          // console.log("on play");
          // requestAnimationFrame(step);
        },
        onend: () => {
          setIsPlaying(false);
        },
      });
      sound.play();

      setSound(sound);
    }
  };
  return (
    <group
      {...props}
      dispose={null}
      onClick={clickHandler}
      onPointerEnter={() => {
        document.body.style.cursor = "pointer";
      }}
      onPointerLeave={() => {
        document.body.style.cursor = "default";
      }}
    >
      {isPlaying && (
        <Sparkles
          count={100}
          scale={1}
          size={100}
          speed={2}
          color={"#00FF00"}
          position={[5.686, 2.5, -3.662]}
        />
      )}
      <group
        position={[5.686, 2.018, -3.662]}
        rotation={[Math.PI, -1.562, Math.PI]}
        scale={0.1}
      >
        <mesh
          geometry={nodes.Violin_Circle005_1.geometry}
          material={materials["795548"]}
        />
        <mesh
          geometry={nodes.Violin_Circle005_1_1.geometry}
          material={materials["455A64"]}
        />
        <mesh
          geometry={nodes.Violin_Circle005_1_2.geometry}
          material={materials["1A1A1A.001"]}
        />
        <mesh
          geometry={nodes.Violin_Circle005_1_3.geometry}
          material={materials["DD9944.001"]}
        />
      </group>
    </group>
  );
}

useGLTF.preload("/Instruments/Violin-transformed.glb");
